import React from 'react';
import PropTypes from 'prop-types';

import { bem } from 'helpers/class-name';
import { msiLastChangePropTypes } from 'constants/propTypes';
import Message from 'components/Message';
import Button from 'components/Button';
import LastUpdate from 'components/LastUpdate';
import messages from '../ScheduleForm.messages';
import { PUBLISHED_STATUS } from '../../Schedules.helpers';
import './ScheduleFormFooter.scss';

const { block, element } = bem('schedule-form-footer');

const ScheduleFormFooter = ({ saveAsDraft, saveAsPublished, deleteSchedule, updateStartDate, status, lastChange }) => (
  <section className={block('ph-l')}>
    <div className={element('buttons')}>
      <Message as={Button} onClick={updateStartDate} styled="tertiary" message={messages.footer.discardChanges} />
      {status && (
        <Message
          as={Button}
          onClick={deleteSchedule}
          className="ml"
          styled="danger"
          message={messages.footer.deleteSchedule}
        />
      )}
    </div>
    <div className={element('buttons')}>
      {lastChange && <LastUpdate {...lastChange} />}
      {status !== PUBLISHED_STATUS && (
        <Message
          as={Button}
          className={element('draft-button')}
          styled="tertiary"
          onClick={saveAsDraft}
          message={messages.footer.saveDraft}
        />
      )}
      <Message as={Button} styled="primary" onClick={saveAsPublished} message={messages.footer.publish} />
    </div>
  </section>
);

ScheduleFormFooter.propTypes = {
  saveAsDraft: PropTypes.func,
  saveAsPublished: PropTypes.func,
  deleteSchedule: PropTypes.func,
  status: PropTypes.string,
  updateStartDate: PropTypes.func,
  lastChange: msiLastChangePropTypes,
};

export default ScheduleFormFooter;
